module.exports = __webpack_public_path__ + "img/img-52.4b090ad2.png";